var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-camp"},[_c('h1',[_vm._v("请务必添加课程学姐微信哦")]),_c('p',[_vm._v("加入训练营，与老师同学一起学习")]),_c('img',{attrs:{"src":_vm.qrCode,"alt":""}}),_c('p',[_vm._v("扫一扫上面的二维码，加我微信")])])
}
var staticRenderFns = []

export { render, staticRenderFns }